<template>
  <div id="app">
    <keep-alive :exclude="['RobotInquiryMultiAdd', 'RobotInquiryAdd', 'EditAddress', 'H5OrderDetails']">
      <router-view/>
    </keep-alive>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'App',
  methods: {
    ...mapActions('user', ['getUserInfo']),
  },
  created() {
    // this.getUserInfo()
    // localStorage.setItem('danlaile-user', JSON.stringify({"status":null,"create_time":null,"update_time":null,"count":null,"user_id":523,"parent_id":0,"org_id":null,"login_mobile":"w.","password":"8BCF2885A462E1C7FA460F6762979DE83B22A2629BA8CE5E7FD76BC09605A129","receive_phone":null,"org_dto":null,"user_type":0,"user_status":1,"union_id":"onzWswtiPgTzJsRzsPuLSEEt4Fyg","erp_customer_id":null,"new_count":null,"org_name":null,"mac_address":null,"invoice_title":null,"user_address_dto":null,"identify":523}))
    // localStorage.setItem('danlaile-url_query', JSON.stringify({"key":"0355af5c35f1a666c174c129fac72bf4","id":"99"}))
    // localStorage.setItem('danlaile-token', JSON.stringify("e79ef453-8bc9-4580-8e7c-644413acad98"))
  },
}
</script>
<style lang="scss" scoped>
#app {
  
	max-width: 375px !important;
	margin: 0 auto;
}
</style>
